import api from '../../../services/api';

export const generateCaption = (payload) => api.post('/smm/ai/generate-caption', payload).then(r => r.data);
export const bestTimes = (params) => api.get('/smm/insights/best-times', { params }).then(r => r.data);
